// extracted by mini-css-extract-plugin
export default {"page":"Artist_page__8SKOQ","title":"Artist_title__d4OyI","artistImage":"Artist_artistImage__8onbt","description":"Artist_description__3++dv"};